import type { AwardsModuleHomePage } from '../../../types/components'

import { Media, MediaContextProvider } from '../Media'
import Desktop from './Desktop'
import Tablet from './Tablet'
import Phone from './Phone'

const ModuleAwardsHomePage = ({
  moduleProps
}: {
  moduleProps: AwardsModuleHomePage['attributes']
}) => {
  return (
    <MediaContextProvider>
      <Media lessThan='md'>
        <Phone {...moduleProps} />
      </Media>
      <Media between={['md', 'lg']}>
        <Tablet {...moduleProps} />
      </Media>
      <Media greaterThanOrEqual='lg'>
        <Desktop {...moduleProps} />
      </Media>
    </MediaContextProvider>
  )
}

export default ModuleAwardsHomePage
